var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6719 11.557H25.3359C24.4611 11.557 23.752 10.9099 23.752 10.1117V4.33008",
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49603 11.557V7.22087C9.49603 5.62433 10.9144 4.33008 12.664 4.33008H24.0244C24.8646 4.33008 25.6702 4.63491 26.2642 5.17708L30.7437 9.26465C31.3379 9.80665 31.6719 10.5418 31.6719 11.3084V27.4564C31.6719 29.0529 30.2536 30.3472 28.504 30.3472H12.664C10.9144 30.3472 9.49603 29.0529 9.49603 27.4564V26.011",
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6134 17.2832L11.6534 20.8967L9.2774 18.7286",
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.74402,
    y: 11.5566,
    width: 15.8399,
    height: 14.4539,
    rx: 5.125,
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/fileicon.03bfdb1296837e21a52f610aaf65e2dd.svg";
export { ForwardRef as ReactComponent };